import { render, staticRenderFns } from "./OrganizationEditor.vue?vue&type=template&id=72c0e7af&scoped=true&"
import script from "./OrganizationEditor.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditor.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationEditor.vue?vue&type=style&index=0&id=72c0e7af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0e7af",
  null
  
)

export default component.exports